<template>
  <div class="by-card2">
    <div v-if="header" class="by-card-header">
      <slot name="header"></slot>
    </div>
    <div class="by-card-body">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    header: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped="scoped">
.by-card2 {
  margin-top: 15px;
  margin-bottom: 15px;
  border-radius: 10px;
  overflow: hidden;
  -webkit-box-shadow: 0 2px 6px rgb(0 0 0 / 10%);
  box-shadow: 0 2px 6px rgb(0 0 0 / 10%);
}
.by-card-header {
  padding: 10px 24px;
  background: #f5f5f5;

  
color: #333333;
font-weight: 600;
font-size: 13px;
}
.by-card-body{
    padding:15px;
  background: #fff;

}
</style>


// WEBPACK FOOTER //
// src/common/components/ByCard.vue